import type { IconSpec } from 'turbotwin-sdk/icons';

/**
 * One icon from the TurboTwin vocabulary (`Icons` from `turbotwin-sdk/icons`)
 * or the portal extension (`PortalIcons`): filled 24x24 path data in
 * `currentColor`. Decorative unless `title` is given.
 */
export function Icon({ of, size = 16, className, title }: { of: IconSpec; size?: number; className?: string; title?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="currentColor"
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title && <title>{title}</title>}
      <path d={of.path} />
    </svg>
  );
}
